"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonFocusRingStyles = void 0;
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _getButtonBorderRadius = require("./getButtonBorderRadius");
const focusRingTheme = (0, _sdsThemeInternal.themed)({
  offset: {
    "lodestar-light": 2,
    "ursa-light": 1
  }
});
const getButtonFocusRingStyles = _ref => {
  let {
    themeMode,
    size
  } = _ref;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    gap: focusRingTheme.offset(themeMode),
    componentBorderWidth: 1,
    componentRadius: _getButtonBorderRadius.borderTheme[size](themeMode),
    theme: themeMode
  });
};
exports.getButtonFocusRingStyles = getButtonFocusRingStyles;
//# sourceMappingURL=getButtonFocusRingStyles.js.map